import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { FormattedMessage } from 'translations';
import { connect } from 'react-redux';
import { formValueSelector, Field } from 'redux-form';
import { Layout, Flex } from 'app/components/base/Layout';
import RelativePickupDatetimeField from 'mz-ui-kit/form/PickupInformationField/RelativePickupDatetimeField';
import Icon from 'app/components/base/Icon';
import {
  BOOK_TRIP_FORM,
  DEPARTING_PICKUP_FIELD_NAME,
  RETURNING_PICKUP_FIELD_NAME,
  DEPARTING_FLIGHT_FIELD_NAME,
  RETURNING_FLIGHT_FIELD_NAME,
  DEPARTING_TRIP_FIELD_NAME,
  DEPARTING_RELATIVE_PICKUP_FIELD_NAME,
  RETURNING_RELATIVE_PICKUP_FIELD_NAME,
} from 'app/constants';

import style from './style.css';

// Constants
export const TYPE_TO_FIELD = {
  departing: DEPARTING_PICKUP_FIELD_NAME,
  returning: RETURNING_PICKUP_FIELD_NAME,
};
export const TYPE_TO_FLGITH_FIELD = {
  departing: DEPARTING_FLIGHT_FIELD_NAME,
  returning: RETURNING_FLIGHT_FIELD_NAME,
};
export const TYPE_TO_RELATIVE_FIELD = {
  departing: DEPARTING_RELATIVE_PICKUP_FIELD_NAME,
  returning: RETURNING_RELATIVE_PICKUP_FIELD_NAME,
};
export const messages = {
  label: { id: 'BOOK_TRIP.PICKUP_TIME' },
  returnLabel: { id: 'BOOK_TRIP.RETURN_PICKUP_TIME' },
  flightLabel: { id: 'BOOK_TRIP.FLIGHT_TIME' },
  returnFlightLabel: { id: 'BOOK_TRIP.RETURN_FLIGHT_TIME' },
  tooltip: { id: 'BOOK_TRIP.PICKUP_TIME_TOOLTIP' },
  availableTime: { id: 'BOOK_TRIP.AVAILABLE_TIME_MESSAGE' },
};
export const selector = formValueSelector(BOOK_TRIP_FORM);
const RELATIVE_PICKUP_DISABLED = true;

// Utils
export const mapStateToProps = (state, { type }) => {
  const value = selector(state, TYPE_TO_FIELD[type]);
  const rawFlight = selector(state, TYPE_TO_FLGITH_FIELD[type]);
  const flight = rawFlight && rawFlight.flightDatetime ? rawFlight : null;
  const trip = selector(state, DEPARTING_TRIP_FIELD_NAME) || {};
  const minDate =
    type === 'returning' ? selector(state, TYPE_TO_FIELD.departing) : null;

  const steps = type === 'departing' ? trip.steps : trip.returnSteps;
  const mainStep = steps && steps.find((x) => x.main);
  const freeWaitingMinutes =
    (mainStep && mainStep.bookingDetails.waitTime) || 0;

  const showLandingTooltip =
    type === 'departing' ? !!trip.flightDatetime : !!trip.returnFlightDatetime;

  return {
    value,
    flight,
    minDate,
    showLandingTooltip,
    trip,
    freeWaitingMinutes,
  };
};

/**
 * Builder to show "Pickup time" label of the field and some
 * platform specific date/time selector component.
 * @param  {Component} ComposedComponent
 * @return {Component}
 */
export const builder = (ComposedComponent) => {
  const WrapperComponent = (props) => {
    const modifiers = {
      [style[`block--${props.type}`]]: true,
    };

    const labelMessages = props.flightTimeSelector
      ? { label: messages.flightLabel, returnLabel: messages.returnFlightLabel }
      : { label: messages.label, returnLabel: messages.returnLabel };

    const labelMessage =
      props.type === 'departing'
        ? labelMessages.label
        : labelMessages.returnLabel;

    if (
      !props.showRelativePicker ||
      props.timeProps ||
      RELATIVE_PICKUP_DISABLED
    ) {
      return (
        <Layout
          className={classnames(style.block, modifiers, props.className)}
          direction="column"
          nowrap
        >
          <Flex size="noshrink">
            <Layout>
              <label className={style.label}>
                <FormattedMessage {...labelMessage} />
              </label>
              {props.showLandingTooltip && (
                <Layout className={style.tooltip} align="start start">
                  <Icon primary className={style.tooltipIcon}>
                    info
                  </Icon>
                  <FormattedMessage {...messages.tooltip} />
                </Layout>
              )}
            </Layout>
          </Flex>
          {(!props.showRelativePicker ||
            props.timeProps ||
            RELATIVE_PICKUP_DISABLED) && (
            <Layout className={style.fields} size="noshrink" nowrap>
              <ComposedComponent
                {...props}
                fieldName={TYPE_TO_FIELD[props.type]}
              />
            </Layout>
          )}
        </Layout>
      );
    }

    if (props.showRelativePicker && props.flight && props.trip) {
      return (
        <div style={{ margin: '0 0 10px 0' }}>
          <Field
            name={TYPE_TO_RELATIVE_FIELD[props.type]}
            component={RelativePickupDatetimeField}
            flightDatetime={props.flight.flightDatetime}
            direction={props.direction === 'toAirport' ? 'dep' : 'arr'}
            rideDuration={props.trip.duration}
            freeWaitingMinutes={props.freeWaitingMinutes}
          />
        </div>
      );
    }

    return null;
  };
  WrapperComponent.defaultProps = {
    type: 'departing',
  };

  // TODO: move to Flow types
  // WrapperComponent.propTypes = {
  //   availableTime: PropTypes.string,
  //   vehicleArriveTime: PropTypes.string,
  //   direction: PropTypes.oneOf(['fromAirport', 'toAirport']),
  //   className: PropTypes.string,
  //   type: PropTypes.oneOf(Object.keys(TYPE_TO_FIELD)),
  //   showLandingTooltip: PropTypes.bool,
  //   showRelativePicker: PropTypes.bool
  // };

  return compose(connect(mapStateToProps))(WrapperComponent);
};

export default builder;
